import React, { useCallback } from 'react';

import { LibraryPageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';
import { notificationApi } from '../../adapters/get-notification';
import { useBatchMoveModal } from './target-folder-picker';

export const LibraryPage = (props) => {
  const renderHelpPopup = useCallback(popupId => (
    <HelpPopupInline
      topic={popupId}
    />
  ), []);

  return (
    <LibraryPageComponent
      {...props}
      notificationApi={notificationApi}
      renderHelpPopup={renderHelpPopup}
      useBatchMoveModalHook={useBatchMoveModal}
    />
  );
};
